import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-typepage',
  templateUrl: './typepage.component.html',
  styleUrls: ['./typepage.component.css']
})
export class TypepageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/typepage/typepage.component.ts